import Quote from './src/main'

Quote.install = function (Vue) {
    Vue.component(Quote.name, Quote)
}

export default Quote;